import { render, staticRenderFns } from "./AffiliateLinksCard.vue?vue&type=template&id=3fc2242e&scoped=true&"
import script from "./AffiliateLinksCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2242e",
  null
  
)

export default component.exports